import React from 'react'
import KeyBenifit from './KeyBenifit'
import one from '../../assets/images/1.webp'
import two from '../../assets/images/2.webp'
import three from '../../assets/images/5.webp'
import four from '../../assets/images/4.webp'
import five from '../../assets/images/3.webp'
// Example usage of the KeyBenifit component (matches current props API)
const KeyBenefitExample: React.FC = () => {
  const cards = [
    { id: 1, 
      title: ' Personalized Tutoring Sessions', 
      content: ' One-to-one online learning tailored to each student’s unique strengths, learning pace, and academic goals. Whether preparing for exams or reinforcing fundamentals, our tutors build a custom learning path that boosts understanding and confidence—without the pressure of a group class. Personalized plans lead to faster progress and better retention.',
      url:one
    },
    { 
      id: 2, 
      title: 'Global Expert Tutors', 
      url:two,
      content: 'Access a handpicked network of certified educators from the USA, UK, Canada, and Australia. Each tutor brings deep subject expertise, local curriculum knowledge, and years of experience in online teaching. No matter where you’re located, you can connect with the world’s best educators from the comfort of your home—any time zone, any schedule.' 
    },
    { 
      id: 3, 
      title: 'Virtual Learning Made Simple', 
      url:three,
      content: 'Our seamless online classroom features interactive whiteboards, real-time collaboration tools, and session recordings—all designed to make remote learning just as effective (and more flexible) than in-person tutoring. With no apps or software to download, students of all ages can join instantly through any device, anywhere in the world.' 
    },
    { 
      id: 4, 
      title: 'Free Demo Classes', 
      url:four,
      content: 'Not sure if online learning is right for you? Try it free—no strings attached. Our demo class gives you a full experience of what it’s like to learn with a professional tutor, tailored to your subject and skill level. It\'s a stress-free way to evaluate the platform, meet your tutor, and see how personalized online education works in real-time.' 
    },
    { 
      id: 5, 
      title: 'Proven Student Success',
      url:five, 
      content: 'Over 95% of our students report academic improvement within 3 months. Our proven teaching methods, data-driven feedback system, and consistent progress tracking ensure that each learner sees measurable growth. From higher test scores to improved class participation, our students don\'t just learn—they thrive.' 
    },
        ]

  return <KeyBenifit cards={cards} />
}

export default KeyBenefitExample
